export default {
  //产品列表
  setFtSolution: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/solution-ft/list.vue'));
    }, '/modules/solution-ft/list');
  },
  //解决方案分类
  solutionFtCategory: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/solution-ft/category/list.vue'));
    }, '/modules/solution-ft/category/list');
  },
  jcnIndustry: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/solution-ft/category/jcn-industry-list.vue'));
    }, '/modules/solution-ft/category/jcn-industry-list');
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/solution-ft.js